import React from "react";
import {
  DashboardEmptyState,
  HubTableTemplate,
} from "../../components";

const items = [
  { id: "partNumber", label: "Part #" },
  { id: "partName", label: "Part Name" },
  { id: "lastSentPrice", label: "Last Price" },
  { id: "createdAt", label: "Created" },
  { id: "createdBy", label: "Created By" },
];

const keys = [
  {
    variant: "blueBold",
    value: "partNumber",
    navigate: true,
    route: "parts",
    id: "id",
  },
  { value: "partName", defaultValue: "—" },
  { value: "lastSentPrice", isCurrency: true },
  { value: "createdAt", isDate: true },
  { value: "createdBy", isUser: true, userProps: { size: "18px" } },
];

export const RecentPartsTable = ({ rows = [], isLoading }) => {
  if (!isLoading && !rows.length) {
    return (
      <DashboardEmptyState
        icon="Codesandbox"
        title="No recent parts"
        subtitle="Newly added parts will appear here."
      />
    );
  }
  return (
    <HubTableTemplate
      id="dashboard-recent-parts"
      headerProps={{ items }}
      bodyProps={{ items: rows, keys }}
      isLoading={isLoading}
    />
  );
};

export default RecentPartsTable;
